import { faEllipsisVertical } from "@fortawesome/pro-solid-svg-icons";
import { Box, Stack } from "@mui/material";
import React from "react";

import { Icon, IconButton, Typography } from "@/components/ui-v2";

type DriveGridItemFooterProps = {
  text: string;
  subText?: string;
  actionsDisabled: boolean;
  onContextMenu: (event: React.MouseEvent) => void;
};

export const DriveGridItemFooter = (props: DriveGridItemFooterProps) => {
  const { text, subText, actionsDisabled, onContextMenu } = props;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Stack sx={{ minWidth: 0 }}>
        <Typography variant="micro" fontWeight="bold" noWrap>
          {text}
        </Typography>
        <Typography variant="micro" color="secondary.2">
          {subText}
        </Typography>
      </Stack>
      {!actionsDisabled && (
        <IconButton
          aria-label="Open options"
          variant="quaternary"
          size="medium"
          onClick={onContextMenu}
        >
          <Icon icon={faEllipsisVertical} />
        </IconButton>
      )}
    </Box>
  );
};
